export default __webpack_public_path__ + "static/media/Vantrust.3c26666b.svg";